export const helperLinkSx = {
  textDecoration: 'none',
};

export const helperLinkTextSx = (theme) => ({
  '&:hover': {
    color: theme.palette.quaternary.main,
  },
});
